import React from 'react'
import { useTranslation } from 'react-i18next'
import { M_Fieldset } from 'src/M_Components'

export const Profile = ({ User }) => {
    const { t } = useTranslation()

    const fieldLabelStyle = {
        fontSize: '13px',
        fontWeight: '700',
        color: 'var(--color-blue)',
        textTransform: 'uppercase',
        letterSpacing: '0.6px',
        marginBottom: '5px',
    }

    const fieldValueStyle = {
        fontSize: '14px',
        color: 'var(--color-black)',
        fontWeight: '500',
    }

    const companyPillStyle = {
        display: 'inline-block',
        backgroundColor: '#f5f6f6',
        color: 'var(--color-black)',
        borderRadius: '20px',
        padding: '4px 12px',
        fontSize: '12px',
        fontWeight: '600',
        margin: '3px',
        whiteSpace: 'nowrap',
        border: '1px solid var(--color-grey)',
    }

    const rolePillStyle = {
        display: 'inline-block',
        backgroundColor: '#e8f4fb',
        color: 'var(--color-blue)',
        borderRadius: '20px',
        padding: '4px 12px',
        fontSize: '12px',
        fontWeight: '600',
        margin: '3px',
        whiteSpace: 'nowrap',
        border: '1px solid var(--color-blue-light)',
    }

    return (
        <div>
            <M_Fieldset
                labelInside
                label={t('Profile')}
                elements={
                    User &&
                    <>
                        {/* Header: Avatar + Nome */}
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '16px',
                            marginBottom: '24px',
                            paddingBottom: '20px',
                            borderBottom: '1px solid var(--color-grey-light)',
                        }}>
                            <div style={{
                                width: '52px',
                                height: '52px',
                                borderRadius: '50%',
                                backgroundColor: 'var(--color-blue-dark)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'white',
                                fontSize: '22px',
                                fontWeight: '700',
                                flexShrink: 0,
                                userSelect: 'none',
                            }}>
                                {User?.User?.UserName?.charAt(0)?.toUpperCase()}
                            </div>
                            <div>
                                <div style={{ fontSize: '18px', fontWeight: '700', color: 'var(--color-black)' }}>
                                    {User?.User?.UserName}
                                </div>
                                <div style={{ fontSize: '13px', color: 'var(--color-grey-dark)', marginTop: '2px' }}>
                                    {User?.Tenant}
                                </div>
                            </div>
                        </div>

                        {/* Grid: Office / Email / Phone */}
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(3, 1fr)',
                            gap: '24px',
                            marginBottom: '24px',
                            paddingBottom: '20px',
                            borderBottom: '1px solid var(--color-grey-light)',
                        }}>
                            <div>
                                <div style={fieldLabelStyle}>{t('Office')}</div>
                                <div style={fieldValueStyle}>{User?.Tenant || '—'}</div>
                            </div>
                            <div>
                                <div style={fieldLabelStyle}>{t('Email')}</div>
                                <div style={fieldValueStyle}>{User?.User?.Email || '—'}</div>
                            </div>
                            <div>
                                <div style={fieldLabelStyle}>{t('Phone')}</div>
                                <div style={fieldValueStyle}>{User?.User?.PhoneNumber || '—'}</div>
                            </div>
                        </div>

                        {/* Roles */}
                        <div style={{ marginBottom: '24px' }}>
                            <div style={fieldLabelStyle}>{t('Roles')}</div>
                            <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '6px' }}>
                                {User?.Role.map((role, i) => (
                                    <span key={i} style={rolePillStyle}>{role.Name}</span>
                                ))}
                            </div>
                        </div>

                        {/* Companies */}
                        <div>
                            <div style={fieldLabelStyle}>{t('Companies')}</div>
                            <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '6px' }}>
                                {User?.Companies.map((company, i) => (
                                    <span key={i} style={companyPillStyle}>{company.Code}</span>
                                ))}
                            </div>
                        </div>
                    </>
                }
            />
        </div>
    )
}
